// Meta's media limits for WhatsApp template header attachments (Cloud API media
// reference) — mirrored on the backend by the equivalent check in
// Api::V1::Accounts::Inboxes::MessageTemplatesController. Kept in sync manually,
// same pattern as templateNameSanitizer.js.
export const HEADER_MEDIA_LIMITS = {
  image: {
    mimeTypes: ['image/jpeg', 'image/png'],
    accept: '.jpg,.jpeg,.png,image/jpeg,image/png',
    maxSizeBytes: 5 * 1024 * 1024,
    formatsLabel: 'JPEG, PNG',
  },
  video: {
    mimeTypes: ['video/mp4', 'video/3gpp'],
    accept: '.mp4,.3gp,video/mp4,video/3gpp',
    maxSizeBytes: 16 * 1024 * 1024,
    formatsLabel: 'MP4, 3GP',
  },
  document: {
    mimeTypes: [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-powerpoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'text/plain',
    ],
    accept:
      '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,text/plain',
    maxSizeBytes: 100 * 1024 * 1024,
    formatsLabel: 'PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, TXT',
  },
};

const formatMb = bytes => `${Math.round(bytes / (1024 * 1024))}MB`;

/**
 * @param {File} file
 * @param {'image'|'video'|'document'} headerType
 * @returns {string|null} an i18n key suffix describing the error, or null if valid
 */
export const validateHeaderMediaFile = (file, headerType) => {
  const limits = HEADER_MEDIA_LIMITS[headerType];
  if (!limits) return null;

  if (!limits.mimeTypes.includes(file.type)) return 'MEDIA_INVALID_TYPE';
  if (file.size > limits.maxSizeBytes) return 'MEDIA_TOO_LARGE';
  return null;
};

export const headerMediaMaxSizeLabel = headerType =>
  formatMb(HEADER_MEDIA_LIMITS[headerType]?.maxSizeBytes || 0);

export const headerMediaFormatsLabel = headerType =>
  HEADER_MEDIA_LIMITS[headerType]?.formatsLabel || '';
